function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m0.52988 20.02c0-10.784 8.7548-19.539 19.539-19.539 10.821 0 19.539 8.7548 19.539 19.539 0 10.821-8.7173 19.539-19.539 19.539-10.784 0-19.539-8.7173-19.539-19.539z",
  fill: "#fff"
}), React.createElement("path", {
  d: "m5.7903 14.61h28.557v12.813c0 2.0666-1.6533 3.7199-3.6823 3.7199h-21.154c-2.029 0-3.7199-1.6533-3.7199-3.7199z",
  fill: "#fff"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m9.5102 8.748h21.154c2.029 0 3.6823 1.6908 3.6823 3.7199v2.1417h-28.557v-2.1417c0-2.029 1.6908-3.7199 3.7199-3.7199z",
  fill: "#ecaec6"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9.8462
}, React.createElement("path", {
  d: "m0.52988 20.02c0-10.784 8.7548-19.539 19.539-19.539 10.821 0 19.539 8.7548 19.539 19.539 0 10.821-8.7173 19.539-19.539 19.539-10.784 0-19.539-8.7173-19.539-19.539"
}), React.createElement("path", {
  d: "m5.5948 14.61h28.948v13.065c0 2.1073-1.6759 3.7932-3.7327 3.7932h-21.444c-2.0568 0-3.7708-1.6859-3.7708-3.7932z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "m9.3656 8.4873h21.444c2.0568 0 3.7327 1.766 3.7327 3.8853v2.237h-28.948v-2.237c0-2.1193 1.714-3.8853 3.7708-3.8853z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "icon-secondary",
  d: "m11.952 9.1237c0-1.2775 0.63876-2.3296 1.3527-2.3296 0.75149 0 1.3527 1.0521 1.3527 2.3296 0 1.3151-0.60119 2.3296-1.3527 2.3296-0.71391 0-1.3527-1.0145-1.3527-2.3296z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "icon-secondary",
  d: "m25.479 9.1237c0-1.2775 0.63876-2.3296 1.3527-2.3296 0.75149 0 1.3527 1.0521 1.3527 2.3296 0 1.3151-0.60119 2.3296-1.3527 2.3296-0.71391 0-1.3527-1.0145-1.3527-2.3296z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 9.8462
}, React.createElement("path", {
  d: "m11.952 9.1237c0-1.2775 0.63876-2.3296 1.3527-2.3296 0.75149 0 1.3527 1.0521 1.3527 2.3296 0 1.3151-0.60119 2.3296-1.3527 2.3296-0.71391 0-1.3527-1.0145-1.3527-2.3296"
}), React.createElement("path", {
  d: "m25.479 9.1237c0-1.2775 0.63876-2.3296 1.3527-2.3296 0.75149 0 1.3527 1.0521 1.3527 2.3296 0 1.3151-0.60119 2.3296-1.3527 2.3296-0.71391 0-1.3527-1.0145-1.3527-2.3296"
}));
var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "icon-secondary",
  fill: "#adb9ca",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m27.504 18.367v3.1562h2.9102v-3.1562z"
}), React.createElement("path", {
  d: "m21.497 18.423v3.1562h2.9102v-3.1562z"
}), React.createElement("path", {
  d: "m9.462 24.401v3.1562h2.9102v-3.1562z"
}));
var _ref8 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 9.8462
}, React.createElement("path", {
  d: "m27.504 18.497h3.0406v3.0259h-3.0406z"
}), React.createElement("path", {
  d: "m27.481 24.475h3.0406v3.0259h-3.0406z"
}), React.createElement("path", {
  d: "m21.497 18.554h3.0406v3.0259h-3.0406z"
}), React.createElement("path", {
  d: "m21.474 24.531h3.0406v3.0259h-3.0406z"
}), React.createElement("path", {
  d: "m15.546 18.488h3.0406v3.0259h-3.0406z"
}), React.createElement("path", {
  d: "m15.523 24.466h3.0406v3.0259h-3.0406z"
}), React.createElement("path", {
  d: "m9.4847 18.554h3.0406v3.0259h-3.0406z"
}), React.createElement("path", {
  d: "m9.462 24.531h3.0406v3.0259h-3.0406z"
}));
var SvgDefineSurveyTabConfigure = function SvgDefineSurveyTabConfigure(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDefineSurveyTabConfigure, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Define-Survey-Tab-Configure.315c7ab6.svg";
export { ForwardRef as ReactComponent };